module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"free":"Free","occupied":"Occupied"},"de":{"free":"Frei","occupied":"Besetzt"},"fr":{"free":"Libre","occupied":"Occupé"},"it":{"free":"Libero","occupied":"Occupato"}}')
  delete Component.options._Ctor
}
